import * as React from 'react';

import { formatDate, Utils } from '@/utils/app';

import TitleBox from './titleBox';

import './index.less';

const icon1 = 'https://diy-assets.msstatic.com/game-release/tgpc2021/comment_icon.png';
const icon2 = 'https://diy-assets.msstatic.com/game-release/tgpc2021/live@3x.png';
const icon3 = 'https://diy-assets.msstatic.com/game-release/tgpc2021/icon3.png';

const { handleClickStrategyRep, jumpGameDetail} = Utils;

function GameIntroduction(props: any) {
  const { introductionData = [], gameBaseInfo = {}, fromId, handTipsImgVis } = props;

  const getJump = (obj: any = {}) => {
    const newObj = {
      position: obj?.index,
      gamename: gameBaseInfo?.gameName,
      gameid: gameBaseInfo?.gameId,
      area: obj.area,
    };
    handleClickStrategyRep(newObj);
    jumpGameDetail({ gameId: gameBaseInfo?.gameId, fromId }, handTipsImgVis);
  };

  const introductionTitleBoxProps = {
    title: '游戏攻略',
    more: '查看全部',
    jumpMore: () => {
      getJump({ area: 'other' });
      jumpGameDetail({ gameId: gameBaseInfo?.gameId, fromId }, handTipsImgVis);
    },
  };

  return (
    <>
      {!!(introductionData || []).length ? <TitleBox {...introductionTitleBoxProps} /> : null}
      <div>
        {(introductionData || []).map((item: any, i: number) => (
          <div className='g-introduction-w' key={`${item.lMomId}_${item.lUid}_${i}`} onClick={() => getJump({ area: 'other', index: i + 1 })}>
            <img className='g-i-w-img' src={item.vMomentAttachment.value[0].sUrl.value[0].sCover} alt='' />
            <div className='g-i-w-middle'>
              <div className='i-w-m-top'>{item.sTitle}</div>
              <div className='i-w-m-footer'>
                <div className='w-m-f-left'>{formatDate(item.iCTime * 1000, 'yyyy-MM-dd')}</div>
                <div className='w-m-f-right'>
                  <div
                    className='b-f-l-icon'
                    onClick={(event: any) => {
                      event.stopPropagation();
                      event.cancelBubble = true;
                      getJump({ area: 'comment', index: i + 1 });
                    }}>
                    <img src={icon1} alt='' />
                    {item.iCommentCount > 9999 ? '9999' : item.iCommentCount}
                  </div>
                  <div
                    className={`b-f-l-icon ${item.iOpt ? 'active' : ''}`}
                    onClick={(event: any) => {
                      event.stopPropagation();
                      event.cancelBubble = true;
                      getJump({ area: 'like', index: i + 1 });
                    }}>
                    <img src={item.iOpt ? icon3 : icon2} alt='' />
                    {item.iFavorCount > 9999 ? '9999' : item.iFavorCount}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default GameIntroduction;
